<template>
  <div class="duty-allocation-detail">
    <el-dialog
      title="值日详情"
      :visible="dutyAllocationDetailShow"
      @open="dialogOpen"
      @close="dialogClose"
      :close-on-click-modal="false"
      width="95%"
      center
    >
      <div class="duty-management" v-bitmap="getListResult">
        <dutyManagement
          ref="duty"
          :teacherDutyData="teacherDutyData"
          :teacherList="teacherList"
          :dutyInfo="dutyInfo"
          :dateList="dateList"
          :editStatus="editStatus"
          :dutyTypeList="dutyTypeList"
          @dialogClose="dialogClose"
          @editStatusChange="editStatusChange"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dutyManagement from "../duty-management/dutyManagement.vue";
export default {
  components: {
    dutyManagement,
  },
  props: ["dutyAllocationDetailShow", "dutyInfo"],
  data() {
    return {
      getListResult: "nullData",
      teacherDutyData: [], // 教师值日列表-值日表数据
      teacherList: [], // 教师列表-用于选择教师时的选择数据绑定
      dateList: [], // 日期列表-用于提交时对日期进行匹配
      editStatus: false, // 是否编辑状态-用于按钮和教师选择框的切换显示
      dutyTypeList: [], // 值日类型列表-用于提交时对值日类型进行匹配
    };
  },
  methods: {
    // 获取期间的所有日期列表
    getDaysBetween(startDate, endDate) {
      // 将输入的字符串日期转换为Date对象
      var startDateObject = new Date(startDate);
      var endDateObject = new Date(endDate);

      // 计算两个日期之间的天数差异
      var daysDiff = Math.floor(
        (endDateObject - startDateObject) / (1000 * 60 * 50 * 24)
      );

      // 初始化结果数组
      var resultArray = [];

      // 生成所有日期
      for (var i = 0; i <= daysDiff; i++) {
        var date = new Date(startDateObject);
        date.setDate(date.getDate() + i);
        resultArray.push(date.toISOString().split("T")[0]);
      }

      return resultArray;
    },
    dialogOpen() {
      this.selectDutyTeacher();
      this.getTeacherList();
      this.getDutyTypeList();
      // 获取当前值日列表起始日期的所有日期
      this.dateList = this.getDaysBetween(
        this.dutyInfo.startDate,
        this.dutyInfo.endDate
      );
    },
    dialogClose() {
      this.teacherDutyData = [];
      this.getListResult = "nullData";
      this.editStatus = false;
      this.$emit("update:dutyAllocationDetailShow", false);
    },
    editStatusChange(e) {
      this.editStatus = e;
    },
    selectDutyTeacher() {
      this.get(
        this.$url.selectDutyTeacher +
          "?dutyId=" +
          this.dutyInfo.id +
          "&schoolId=" +
          this.user.schoolId
      )
        .then((res) => {
          if (res.code == 200) {
            this.teacherDutyData = res.data.map((item) => {
              return item.map((itemF) => {
                // 如果itemF(该值日没有绑定教师)没有数据，则添加一个包含teacherIds的对象，用于选择教师时的数据绑定
                if (itemF === null) {
                  return [
                    {
                      teacherIds: [],
                    },
                  ];
                } else if (typeof itemF == "object") {
                  // 如果不是为空，则在第一个下标的itemF(教师数据)中添加teacherIds，
                  // 并根据是否包含teacherId添加teacherId或teacherName到teacherIds中，用于选择教师时的数据绑定显示
                  itemF[0].teacherIds = [];
                  // 如果是自定义添加的老师没有teacherId,只能使用teacherName
                  itemF.map((itemT) => {
                    let teacherInfo = itemT.teacherId
                      ? itemT.teacherId
                      : itemT.teacherName;
                    itemF[0].teacherIds.push(teacherInfo);
                  });
                }
                return itemF;
              });
            });
            // console.log("this.teacherDutyData:", this.teacherDutyData);
            this.getListResult = "success";
          } else {
            this.$message.error("获取失败，请稍后重试");
            this.getListResult = "error";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取值日类型
    getDutyTypeList() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.selectDutyTypeList, data).then((res) => {
        // console.log("获取学校值日类型==>", res);
        if (res.code != 200) {
          return this.$message.error("获取值日类型失败");
        }
        this.dutyTypeList = res.rows;
      });
    },
    // 获取教师列表
    getTeacherList() {
      this.post(this.$url.selectTeacherListByAdminPC, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          // console.log(res);
          if (res.code != 200) {
            this.$message.error("获取教师列表失败！");
            return;
          }
          let data = res;
          this.teacherList = data.rows;
        })
        .catch((err) => {
          this.$message.error("获取教师列表失败，请稍后再试");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./duty-allocation-detail.scss";
</style>